import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [fullName, setFullName] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isRegister) {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: credentials.email,
            password: credentials.password,
            full_name: fullName
          })
        });

        if (response.ok) {
          toast.success('Registration successful! Please login.');
          setIsRegister(false);
        } else {
          const error = await response.json();
          toast.error(error.detail || 'Registration failed');
        }
      } else {
        const formData = new FormData();
        formData.append('username', credentials.email);
        formData.append('password', credentials.password);

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          localStorage.setItem('admin_token', data.access_token);
          toast.success('Login successful!');
          navigate('/admin/dashboard');
        } else {
          toast.error('Invalid email or password');
        }
      }
    } catch (error) {
      console.error('Auth error:', error);
      toast.error('Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper py-12 px-4 sm:px-6 lg:px-8 min-h-screen flex items-center justify-center" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-white rounded-3xl p-8 shadow-[0_20px_40px_rgba(255,184,0,0.15)]" data-testid="admin-login-form">
          <h1 className="text-4xl font-black font-['Fredoka'] text-[#3A1C00] text-center mb-2" data-testid="admin-login-title">
            {isRegister ? 'Register' : 'Admin Login'}
          </h1>
          <p className="text-[#7D5A35] text-center mb-8">Access your dashboard</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            {isRegister && (
              <div>
                <label className="block text-[#3A1C00] font-['Fredoka'] font-bold mb-2" htmlFor="fullName">
                  Full Name
                </label>
                <input
                  type="text"
                  id="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="admin-input"
                  placeholder="John Doe"
                  required
                  data-testid="admin-fullname-input"
                />
              </div>
            )}

            <div>
              <label className="block text-[#3A1C00] font-['Fredoka'] font-bold mb-2" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                className="admin-input"
                placeholder="admin@mangocosmetics.com"
                required
                data-testid="admin-email-input"
              />
            </div>

            <div>
              <label className="block text-[#3A1C00] font-['Fredoka'] font-bold mb-2" htmlFor="password">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="admin-input"
                placeholder="••••••••"
                required
                data-testid="admin-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full text-lg py-4"
              data-testid="admin-submit-button"
            >
              {loading ? 'Processing...' : (isRegister ? 'Register' : 'Login')}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => setIsRegister(!isRegister)}
              className="text-[#FF6B9E] font-bold hover:text-[#FF4785] transition-colors"
              data-testid="toggle-register-button"
            >
              {isRegister ? 'Already have an account? Login' : "Don't have an account? Register"}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;